import React from 'react'
import { IconsModel } from './types/iconsModel'

const SvgMapPin = (
	{
		color,
		width = 19.182,
		height = 23
	}: IconsModel
) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 19.182 23">
		<g id="Icon_feather-map-pin" data-name="Icon feather-map-pin" transform="translate(1 1)">
			<path id="Tracé_154" data-name="Tracé 154" d="M21.682,10.091c0,6.682-8.591,12.409-8.591,12.409S4.5,16.773,4.5,10.091a8.591,8.591,0,1,1,17.182,0Z" transform="translate(-4.5 -1.5)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
			<path id="Tracé_155" data-name="Tracé 155" d="M19.227,13.364A2.864,2.864,0,1,1,16.364,10.5a2.864,2.864,0,0,1,2.864,2.864Z" transform="translate(-7.773 -4.773)" fill="none" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
		</g>
	</svg>
)

export default SvgMapPin
